import React from 'react';
import ComponentProfileTile from '../Profile/ComponentProfileTile';
import { useState, useEffect } from "react";

const characterColor = '#9B3EBB';       // 文字色 (このファイルで共通の紫文字色)


const ComponentDetailTileP = ({ children }) => {
    return (
        <p style={{
            // color: characterColor
            color: "var(--common-main-color)"
        }}>
            {children}
        </p>
    );
}



const ComponentDetailTile = ({ icon, title, content }) => {
    const [isDesktop, setIsMobile] = useState(window.innerWidth > 767);
    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth > 767);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <ComponentProfileTile
            icon={icon}
            title={title}
            text={content}
            isTextBold={false}
            customWidth={(isDesktop) ? '70%' : '90%'}
            isMerginAuto={true}
            textFlex={false}
        />
    );
}


export {ComponentDetailTileP, ComponentDetailTile};


